"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STRATEGY_VALUES = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_STRATEGY_VALUES = (0, gql_1.gql)(`
   query StrategyValues(
    $productTreeNodeId: ID!,
    $catalogId: ID!,
    $sort: [ProductTreeNodeUniqueLabelValueViewOrderBy!],
    $filter: ProductTreeNodeUniqueLabelValueViewListFilter,
    $label: String!,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productPresentationsNew(catalog: $catalogId) {
        totalCount
      }
      labelValidation(filter: { some: { label: { equals: $label } } }) {
        edges {
          node {
            label
            description
            values(sort: $sort, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
              edges {
                node {
                  value
                  description
                }
              }
              pageInfo {
                hasNextPage
                endCursor
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
